var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEidIconBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9539 4.41276L7.79312 10.5727C7.17963 11.1861 5.3585 11.4702 4.95165 11.0634C4.54481 10.6567 4.8225 8.83578 5.43599 8.22236L11.6033 2.05594C11.7553 1.89003 11.9394 1.75667 12.1445 1.66388C12.3496 1.57109 12.5713 1.52079 12.7964 1.51605C13.0214 1.51132 13.2451 1.55222 13.4539 1.6363C13.6627 1.72037 13.8523 1.8459 14.0112 2.00526C14.1701 2.16462 14.2951 2.35452 14.3786 2.5635C14.4621 2.7725 14.5025 2.99623 14.4971 3.22123C14.4918 3.44622 14.4408 3.66782 14.3475 3.8726C14.2541 4.07739 14.1203 4.26115 13.9539 4.41276Z",
    stroke: "#00A35E",
    strokeWidth: 1.19273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31499 2.86317H4.08607C3.40097 2.86317 2.74398 3.13529 2.25955 3.61966C1.77512 4.10403 1.50293 4.76097 1.50293 5.44598V11.903C1.50293 12.588 1.77512 13.2449 2.25955 13.7293C2.74398 14.2137 3.40097 14.4858 4.08607 14.4858H11.1897C12.6169 14.4858 13.127 13.3235 13.127 11.903V8.67448",
    stroke: "#00A35E",
    strokeWidth: 1.19273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEidIconBooking);
export default __webpack_public_path__ + "static/media/EidIconBooking.02f32cc46120e3488fb0816e24e4529c.svg";
export { ForwardRef as ReactComponent };